/**
 * ProfileNotifications.jsx — sub-page hosting push opt-in.
 * Feb 26 2026 Profile restructure.
 */
import React from 'react';
import { Bell } from 'lucide-react';
import ProfileSubPage from '../components/ProfileSubPage';
import NotificationOptIn from '../components/NotificationOptIn';
import ListenerCard from '../components/ListenerCard';

const ProfileNotifications = () => (
  <ProfileSubPage title="Notifications" icon={Bell} accent="amber">
    <NotificationOptIn />
    <ListenerCard />
  </ProfileSubPage>
);

export default ProfileNotifications;
